<template>
    <v-row class="row-announce">
        <div v-if="list_announce.length != 0">
            <v-btn fab dark small v-if="less" @click="less = !less; show = false;"
                style="position: fixed; right: 1%;z-index: 2;background: #2562afd4;">
                <v-icon style="font-size: 15px;">fas fa-bullhorn</v-icon>
            </v-btn>
            <v-card
                style=" position: fixed; width: calc(100vw - calc(31% - -20px)); z-index: 2;  margin-left: 13px; margin-top: -12px; background: none;"
                v-else id="list_height">
                <v-slide-y-transition>
                    <v-card-text v-show="show" style="padding: 0px !important;">
                        <v-list dense style="max-height: 320px;" class="scrolling-wrapper-y">
                            <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
                                <v-list dense>
                                    <v-list-item v-for="(item, index) in ListMenuRightClick" :key="index"
                                        @click="emitListBottom(item)">
                                        <v-list-item-title>{{
                                            item.message
                                            }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                            <template v-for="(item, index) in list_announce">
                                <v-list-item :key="item.index"
                                    @contextmenu="RightClickDialog($event, ['cancel_announce'], item)"
                                    class="list-announce">
                                    <v-list-item-action>
                                        <v-icon style="font-size: 18px;">fas fa-bullhorn</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title style="font-size: 13px;"
                                            v-html="convertMention(item.message_info.message, item)"></v-list-item-title>
                                        <v-list-item-subtitle style="font-size: 12px;">{{ item.nickname
                                            }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider v-if="index + 1 < list_announce.length" :key="index"></v-divider>
                            </template>
                        </v-list>
                    </v-card-text>
                </v-slide-y-transition>
                <v-card-actions v-if="!show" style="background: #2562afa6; height: 40px;">
                    <v-icon style="font-size: 18px; color: #1b232c;">fas fa-bullhorn</v-icon>
                    <p class="mb-0"
                        style="color: black; padding-left: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; cursor: pointer; font-size: 13px;"
                        @contextmenu="RightClickDialog($event, ['cancel_announce'], list_announce[0])"
                        v-html="convertMentionAnnounce(list_announce[0].message_info.message)"></p>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="show = !show" small>
                        <v-icon>fa-solid fa-angle-down</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-card-actions v-if="show" style="color: white;background: #2562af;height: 40px;">
                    <p class="p-announce" @click="delete_announce()">{{ $t('ChatSide.announce.delete') }}</p>
                    |
                    <p class="p-announce" @click="less = !less">{{ $t('ChatSide.announce.minimize') }}</p>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="show = !show" small>
                        <v-icon style="color: white;">fa-solid fa-angle-up</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </v-row>
</template>
<script>
var _ = require('lodash');
export default {
    props: {
        stateAnnounce: Boolean,
        list_announce: Array,
        tokenuser: String,
        statemember: String,
        tokenroom: String,
    },
    data() {
        return {
            show: false,
            less: false,
            ListMenuRightClick: [],
            showMenu: false,
            x: 0,
            y: 0,
        }
    },
    created() {
        this.less = false
        var announce = this.$cookie.get(this.tokenroom)
        // console.log(announce)
        if(announce !== null && announce !== 'null') {
            this.less = true
        } else {
            this.less = false
        }
    },
    watch: {
        tokenroom() {
            var announce = this.$cookie.get(this.tokenroom)
            // console.log("watch announce =>", announce);
            this.show = false
            if(announce !== null && announce !== 'null') {
                this.less = true
            } else {
                this.less = false
            }
        },
        less() {
            if (this.less) {
                this.$cookie.set(this.tokenroom, 'less')
            } else {
                this.$cookie.delete(this.tokenroom)
            }
        },
    },
    methods: {
        cancel_announce(item) {
            this.showMenu = false
            var token_announce = item._id
            this.$swal({
                text: this.$t('Alert.Chat.announce.cancel'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2562af',
                cancelButtonColor: '#9f9f9f',
                confirmButtonText: this.$t('AnswerQuestion.ok'),
                cancelButtonText: this.$t('AnswerQuestion.cancel'),
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-success',
                buttonsStyling: true,
                showCloseButton: true,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/disable_single_announce_room', {
                        tokenuser: this.tokenuser,
                        tokenroom: this.tokenroom,
                        token_announce: token_announce
                    }).then((responsed) => {
                        if (responsed.data.status == 'success') {
                            var index = _.findIndex(this.list_announce, function (o) { return o._id === token_announce })
                            if (index >= 0) {
                                this.list_announce.splice(index, 1)
                            }
                        } else {
                            this.list_announce = []
                        }
                    })
                }
            })
        },
        delete_announce() {
            this.$swal({
                text: this.$t('Alert.Chat.announce.deleteAll'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2562af',
                cancelButtonColor: '#9f9f9f',
                confirmButtonText: this.$t('AnswerQuestion.ok'),
                cancelButtonText: this.$t('AnswerQuestion.cancel'),
                confirmButtonClass: 'btn btn-danger',
                cancelButtonClass: 'btn btn-success',
                buttonsStyling: true,
                showCloseButton: true,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/disable_announce_room', { tokenuser: this.tokenuser, tokenroom: this.tokenroom }).then((responsed) => {
                        if (responsed.data.status == 'success') {
                            this.list_announce = []
                            this.$emit('emitMessage', { methods: 'announce', value: false })
                        }
                    })
                }
            })
        },
        emitListBottom(item) {
            // console.log("emitListBottom =>", item);
            if (item.methods === 'cancel_announce') {
                this.cancel_announce(item.value);
            }
        },
        RightClickDialog(e, list, item) {
            // console.log(item);
            e.preventDefault(); // คลิกขวาแล้วไม่ให้แสดงเมนูของเว็บเบราว์เซอร์
            this.ListMenuRightClick = []
            if (this.statemember === 'active') {
                if (list.includes("announce")) {
                    this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.announce'), methods: 'announce', value: item })
                }
                if (list.includes("cancel_announce")) {
                    this.ListMenuRightClick.push({ message: this.$t('ChatSide.RightClickMenu.cancelAnnounce'), methods: 'cancel_announce', value: item })
                }
                if (this.ListMenuRightClick.length !== 0) {
                    var me = this;
                    this.x = e.clientX - 150;
                    this.y = e.clientY;

                    this.$nextTick(() => {
                        me.showMenu = true;
                    });
                }
            }
        },
        convertMentionAnnounce(msg) {
            msg = msg.replace(/\<tax>/g, '<span style="color:white;">@');
            msg = msg.replace(/<\/tax>/g, '</span>');
            // console.log(msg)
            return msg
        },
        convertMention(msg, item) {
            var linkifyStr = require('linkifyjs/string')
            var str = msg
            var processedContent = linkifyStr(str, { target: { url: '_blank' } })
            var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g
            var color = ''
            if (item.tokenuser == this.tokenuser) {
                // color = '#06bee1'
                color = '#2d76d2'
            } else {
                color = '#1976d2'
            }
            // console.log(style)
            if (msg.match(regex)) {
                for (var i = 0; i < msg.match(regex).length; i++) {
                    processedContent = processedContent.replace('&lt;tax&gt;', `<b style="color: ${color};">@`)
                    processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
                    processedContent = processedContent.replace('\t', '\u00a0\u00a0\u00a0\u00a0\u00a0')
                }
            }
            return processedContent
        },
    },
}
</script>
<style scoped>
.p-announce {
    cursor: pointer !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
    margin-bottom: 0px !important;
}

.p-announce:hover {
    /* color: #1b232c !important; */
    text-decoration: underline !important;
    margin-bottom: 0px !important;
}

.row-announce {
    width: 100%;
    position: absolute;
    z-index: 1;
    margin-top: 60px;
    background-color: antiquewhite;
}

.list-announce {
    height: 50px;
    cursor: pointer !important;
}

.list-announce:hover {
    cursor: pointer !important;
    background: #b4d1f478 !important;
}

.scrolling-wrapper-y {
    /*display: flex;*/
    overflow-y: auto;
}

.scrolling-wrapper-y::-webkit-scrollbar {
    height: 4px;
    width: 8px;
}

.scrolling-wrapper-y::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: rgba(0, 0, 0, .1);
}
</style>